import clsx from 'clsx'

import { useQuickAdd, isVariantOutOfStock, getVariantSizeLabel } from 'libs/athos/hooks/useQuickAdd'
import LoaderSpin from 'libs/athos/components/LoaderSpin'

export function ResultQuickAdd({ result, device = 'both', className = '', showByDefault = false }) {
  // This is wrapped in a div emulating sizing of the ResultImage component
  // This is done as to keep the placement of the quick add, but as to not violate nesting rules for a tags

  const { isAvailable, isComingSoon, addingId, addVariant } = useQuickAdd(result)

  if (!isAvailable) return null

  return (
    <>
      <div
        className={clsx(className, 'aspect-[178/281] lg:aspect-3/4 z-20 bg-transparent pointer-events-none', device === 'both' && 'hidden lg:block', device === 'mobile' && 'hidden')}
      >
        <div className={clsx('pointer-events-auto absolute inset-x-0 bottom-0 flex items-center justify-center bg-transparent z-20 p-1.5', showByDefault ? 'opacity-100' : 'opacity-0 group-hover/card:opacity-100')}>
          <div className="bg-brand-paper/90 rounded-lg py-0.5 w-full">
          {/* Coming Soon replaces the size row rather than hiding the overlay:
              the product IS in stock, it just can't be bought until launch, and
              an absent control reads as "sold out". The PDP carries the release
              date and the Register-to-be-notified form. */}
          {isComingSoon ? (
            <div className="flex w-full items-center justify-center py-0.375" data-ui="disabled">
              <span className="text-xs leading-none font-medium uppercase font-untitled-sans tracking-0.4 text-type-disabled">
                Coming Soon
              </span>
            </div>
          ) : (
          <div className="divide-x divide-type-white-tertiary flex flex-row gap-x-[1px] py-0.25 w-full">
            {result.variants.map((variant) => {
              const isOutOfStock = isVariantOutOfStock(variant)
              const isAdding = addingId === variant.id
              const isMultiple = result.variants.length > 1
              return (
                <button
                  key={variant.id}
                  type="button"
                  className={`relative flex px-0.5 xxl:px-0.875 py-0.375 flex-1 items-center justify-center text-center uppercase text-type-black-primary ${isOutOfStock ? 'pointer-events-none text-type-disabled' : 'opacity-100 hover:underline'
                    }`}
                  onClick={(event) => addVariant(event, variant)}
                  disabled={isOutOfStock || isAdding}
                  aria-busy={isAdding}
                  aria-label={`Add size ${getVariantSizeLabel(variant)} to bag`}
                  data-ui={isOutOfStock ? 'disabled' : ''}
                >
                  {isMultiple ? (
                  <span className={`text-xs leading-none font-medium uppercase font-untitled-sans tracking-0.4 min-w-1 ${isAdding ? 'opacity-0' : ''}`}>{getVariantSizeLabel(variant)}</span>
                  ) : (
                    <span className={`text-xs leading-none font-medium uppercase font-untitled-sans tracking-0.4 min-w-1 ${isAdding ? 'opacity-0' : ''}`}>Add to Bag</span>
                  )}
                  {isAdding && <LoaderSpin wrapperClass="bg-transparent" spinClass="border-t-grey-900" />}
                </button>
              )
            })}
          </div>
          )}
          </div>
        </div>
      </div>
    </>
  )
}
